import {
  useModalContents,
  ModalContentsProvider,
} from './ModalContentsContext';

export default ModalContentsProvider;
export { useModalContents };
